/**
 * Slice Redux pour les relevés de notes
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReleveNotes } from '../../types';

interface ReleveState {
  releves: ReleveNotes[];
  currentReleve: ReleveNotes | null;
  loading: boolean;
  error: string | null;
}

const initialState: ReleveState = {
  releves: [],
  currentReleve: null,
  loading: false,
  error: null,
};

const releveSlice = createSlice({
  name: 'releves',
  initialState,
  reducers: {
    setReleves: (state, action: PayloadAction<ReleveNotes[]>) => {
      state.releves = action.payload;
    },
    setCurrentReleve: (state, action: PayloadAction<ReleveNotes | null>) => {
      state.currentReleve = action.payload;
    },
    addReleve: (state, action: PayloadAction<ReleveNotes>) => {
      state.releves.unshift(action.payload);
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setReleves,
  setCurrentReleve,
  addReleve,
  setLoading,
  setError,
  clearError,
} = releveSlice.actions;

export default releveSlice.reducer;
